import React from 'react';
import { Button } from "reactstrap";

export default function ButtonLoader(props) {
    const { disabled, loading, btntext, ...rest } = props;
    const _loading = loading === undefined ? disabled : loading;
    return (
        <Button
            disabled={disabled}
            {...rest}
        >{_loading && <i className="fa fa-spinner fa-lg spinner mr-1" />}  {btntext}
        </Button>
    )
}